module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Content_Related Widget
(function (fox){

	const hoverVideo = require('../../../site/root/components/hoverVideo')(fox, $);

	fox.registerWidget('Content_Scenes', {

		configure: function (options) {

			this.registerOptions('', {
				autoRender: true,
				preset: 'lastAddedScenes',
				list: {
					handleDom: {
						rollOver: {
							target: '.item .imgpicker',
							event: 'mouseover',
							callback: 'handlerDom:rollOver'
						},
						titleMove: {
							target: '.title',
							event: 'mouseover',
							callback: 'handlerDom:titleMove'
						},
						titleMoveBack: {
							target: '.title',
							event: 'mouseout',
							callback: 'handlerDom:titleMoveBack'
						},
						error: {
							target: '.item .errorimg',
							event: 'error',
							callback: 'handlerDom:errorImg'
						},
						following:{
							target: '.over-timeline',
							event: 'click',
							callback: function (elt) {
								hoverVideo.followingLink(elt)
							}
						},
						addPrevVideo: {
							event: 'mouseover',
							target: '.over-timeline',
							callback: function (elt, w) {
								var w = this;
								if (fox.utils.isTouchDevice()) return;
								hoverVideo.hoverPreviewVideo(elt, this);
							}
						},
						removePrevVideo: {
							event: 'mouseleave',
							target: '.over-timeline',
							callback: function (elt) {
								var w = this;
								hoverVideo.stopHoverPreviewVideo(elt, this)
							}
						}
					},
					'hooks.onStopRendering': function() {
						var elmArr = this.dom('.over-timeline');
						hoverVideo.handleTouch(elmArr, this)
					}
				},
				'widgets.dl': {
					widget: 'Datalayer',
					'metaFields.resources.thumb': 'baseline.sprite.w225i'
				}

			});
			this.callParent('configure', arguments);
		},

	}, 'Content_Browser');

})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/publisher/widget/content/scenes.js
// module id = 442
// module chunks = 4